import React, {useEffect} from 'react';
import SendingPopup from '../../../component/sendingPopup/SendingPopup';
import {useSelector} from 'react-redux';
import {TState} from '../../../redux/store.type';
import {TShow} from '../../../component/prompotionPopup/PromotionPopup';
import useRestartXHR from '../../../hooks/useRestartXHR';
import {useCrmSend} from '../hooks/useCrmSend';
import {createSendingProps} from '../../../component/sendingPopup/services/createSendingProps';
import {useSendData} from '../../../hooks/useSendData';
import {useTranslation} from 'react-i18next';
import {getCrmRecipients} from '../../../redux/crm/crmActions';
import {serializeStructure} from '../../../component/whatsAppTemplateEditor/hooks/useTemplateStructure';

function CrmSendingPopup({show}: {show: TShow}) {
    const sendingXHR = useSelector((state: TState) => state.crm.sendCrmMessageXHR);
    const crmRecipients = useSelector((state: TState) => state.crm.crmRecipients);
    const hasWhatsappPermission = useSelector((state: TState) => state.account.permissions?.find(p => p.permission === 'whatsApp')?.status === 1);
    const queryFilter = useSelector((state: TState) => state.crm.queryFilter);
    const freeFilter = useSelector((state: TState) => state.crm.freeFilter);
    const status = useSelector((state: TState) => state.crm.status);
    const eventType = useSelector((state: TState) => state.event.type);

    const {t} = useTranslation('mailing');
    const allowedList = [...(hasWhatsappPermission ? ['whatsapp'] : []), 'email', 'sms'];

    const isGivechak = eventType === 'givechak';
    const translationKeys = isGivechak ? {
        defaultMessage: 'mailingCrmWhatsappGivechak',
        defaultSubject: 'mailingCrmSubjectGivechak',
        defaultEmailBody: 'mailingCrmEmailGivechak',
        defaultSmsMessage: 'mailingCrmSmsGivechak',
    } : {
        defaultMessage: 'mailingCrmWhatsapp',
        defaultSubject: 'mailingCrmSubject',
        defaultEmailBody: 'mailingCrmDefaultText',
        defaultSmsMessage: 'mailingCrmDefaultText',
    };

    // Custom hooks for data management and send logic
    const {whatsappData, emailData, smsData, handleDataSave, whatsappTemplate} = useSendData({
        defaultMessage: t(translationKeys.defaultMessage),
        defaultSubject: t(translationKeys.defaultSubject),
        defaultEmailBody: t(translationKeys.defaultEmailBody),
        defaultSmsMessage: t(translationKeys.defaultSmsMessage),
        type: 'crm'
    });
    const {handleSend} = useCrmSend({whatsappData: {...whatsappData, message: serializeStructure(whatsappTemplate)}, emailData, smsData, show});

    // XHR restart hook
    useRestartXHR(sendingXHR, 'crm.sendCrmMessageXHR');

    // Create props using utility function
    const {whatsappProps, emailProps, smsProps} = createSendingProps({
        whatsappData,
        emailData,
        smsData,
        handleDataSave,
        handleSend,
        sendingXHR,
        whatsappTemplate,
        variablesType: 'crm'
    });

    useEffect(() => {
        getCrmRecipients().then();
    }, [queryFilter, freeFilter, status]);
    return (
        <>
            {show.isOpen && (
                <SendingPopup 
                    show={show} 
                    whatsappProps={whatsappProps} 
                    smsProps={smsProps} 
                    emailProps={emailProps}
                    amount={crmRecipients}
                    amountText={'transactions'}
                    variablesType={'crm'}
                    allowedList={allowedList}
                />
            )}
        </>
    );
}

export default CrmSendingPopup;

